export const config = {
  listTitle: '账号列表',
  searchFormConfig: false,
  columns: [
    {
      name: 'name',
      label: '客户姓名',
      itemType: 'input',
      placeholder: '请输入姓名查询'
    },
    {
      name: 'phone',
      label: '客户电话',
      itemType: 'input',
      placeholder: '请输入电话查询'
    },
    {
      name: 'id',
      label: '销售计划id',
      itemType: 'input',
      placeholder: '请输入id'
    },
    {
      name: 'memberFlag',
      label: '是否注册会员',
      itemType: 'select',
      key: 'value',
      data: 'booleanOptions',
      notFoundContent: '请选择是否注册会员',
      addonOpts: [],
    },
    {
      name: 'channelId',
      label: '客户来源',
      itemType: 'cascader',
      placeholder: '请选择客户来源',
      key: 'value',
      labelKey: 'label',
      value: 'value',
      data: 'customerOrigin',
    },
    {
      name: 'buildingId',
      label: '楼盘名称',
      itemType: 'select',
      key: 'value',
      data: 'buildOptions',
      notFoundContent: '请选择楼盘名称',
      addonOpts: [],
    },
    {
      name: 'houseNatureCode',
      label: '房屋属性',
      itemType: 'select',
      key: 'key',
      data: 'houseNatureCode',
      notFoundContent: '请选择房屋属性',
      labelKey: 'description',
      addonOpts: [],
    },
    {
      name: 'treeOrg',
      label: '所属组织',
      itemType: 'tree',
      events: ['onChange:handleOrgChange'],
      placeholder: '请选择所属组织',
      key: 'id',
      labelKey: 'label',
      data: 'treeList',
    },
    {
      name: 'salesman',
      label: '营销员',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'personList',
      notFoundContent: '请选择营销员',
      addonOpts: [],
    },
    {
      name: 'designer',
      label: '整装设计师',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'personList',
      notFoundContent: '请选择整装设计师',
      addonOpts: [],
    },
    {
      name: 'softDesign',
      label: '软装设计师',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'personList',
      notFoundContent: '请选择软装设计师',
      addonOpts: [],
    },
    {
      name: 'tailorMadeDesign',
      label: '定制设计师',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'personList',
      notFoundContent: '请选择定制设计师',
      addonOpts: [],
    },
    {
      name: 'status',
      label: '客户状态',
      itemType: 'select',
      key: 'key',
      data: 'trackPlanCode',
      notFoundContent: '请选择客户状态',
      labelKey: 'description',
      addonOpts: [],
    },
    {
      name: 'createdTime',
      label: '创建时间',
      itemType: 'autoDate',
      placeholder: '请选择创建时间',
      showTime: true,
    },
    {
      name: 'lastUpdatedTime',
      label: '最后跟进时间',
      itemType: 'autoDate',
      placeholder: '请选择最后跟进时间',
      showTime: true,
    },
  ],
};